import { useMemo } from 'react';
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import VideoSection from './graph/video';
import { updateOnBoardingSettings } from '../../../../../../store/actions/creator/creatorOnBoarding';
import useWindowSize from '../../../../../../helper/hooks/useWindowSize';

const useStyles = makeStyles(() => ({
  root: {
    zIndex: 1001,
    position: 'fixed',
    marginBottom: -10,
    marginTop: -17,
    marginLeft: -320
  },
}));

function DraggableVideoSection(props: any) {

  const { width } = useWindowSize();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { onVideoPlay } = props;
  const { module4Settings, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { youtube, module4Data } = userPreferences;

  const { session, analyze } = module4Data.value;
  const { session_type } = session;
  const stimulus = analyze.stimulus;
  const { graphZoom, analyseEnd, analyseStart } = module4Settings;

  const {thumbnail, url} = JSON.parse(youtube.value);

  const play_url = session?.stimulus[0]?.play_url;

  const graphLength = useMemo(() => {
    if (stimulus && session_type === 'ASYNC') return stimulus.stimulus_video_length;
    return analyseEnd - analyseStart
  }, [stimulus, analyseEnd, analyseStart]);

  const handleVideoPlay = () => {
    onVideoPlay();
  };

  return (

    <div className={classes.root} style={{right: width / 2 - 40}}>
      <VideoSection
        width={240}
        height={135}
        video={play_url || url}
        videoStart={0}
        videoEnd={stimulus ? stimulus.stimulus_video_length : graphLength}
        img={thumbnail}
        popOut={(e: any) => dispatch(updateOnBoardingSettings('xScroll', e * 15 / Math.pow(graphZoom, 2)))}
        position={'fixed'}
        sessionType={'ASYNC'}
        graphLength={graphLength}
        onVideoPlay={handleVideoPlay}
      />
    </div>
  )
}

export default DraggableVideoSection;